import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="flex items-center gap-2 font-mono text-xs font-medium uppercase tracking-[0.25em] text-viol">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-sun" />
        {children}
    </p>
);
